import React from "react";
import { Box, Flex } from "reflexbox/styled-components";
import styled from "styled-components";
import { getFormattedNamesFromArray, getFormattedTime } from "../../util/util";
import FavoriteToggleButton, { StyledFavButton } from "../../components/buttons/favorite-toggle-button/FavoriteToggleButton";
import { withLocalizeStrings } from "../../languages/Localize";
import { useApplicationStateValue } from "../../application/Application";
import { useHistory } from "react-router-dom";
import routes from "../../config/routes";

export const StyledItemContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
`;

export const StyledTimeLabel = styled(Flex)`
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    justify-content: center;
    align-items: center;
    height: 32px;
    width: 100%;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

const StyledSpan = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.light};
`;

const StyledRoom = styled(StyledSpan)`
    margin-left: ${({ theme }) => theme.space[2]}px;
`;

const StyledItem = styled(StyledItemContainer)`
    color: ${({ theme }) => theme.colors.white};
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.white};
    border-left: none;
    border-right: none;
`;

const StyledItemHeaderContainer = styled(Flex)`
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    line-height: 1;
`;

const StyledContainer = styled(Box)`
    display: block;
    width: 100%;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.white};
`;

const StyledItemHeader = styled(Box)`
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    width: 70%;
`;

const StyledParticipants = styled(Box)`
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    width: 100%;
    flex-wrap: wrap;
`;

const StyledItemFooter = styled(Flex)`
    width: 100%;
    justify-content: flex-end;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    text-transform: uppercase;
`;

const SpeechBlock = ({ strings, item, positionHandler }) => {
    const { push } = useHistory();
    const {
        appData: { forumPanels, forumSpeakers }
    } = useApplicationStateValue();

    const onClickHandler = id => {
        positionHandler();
        const impression = forumPanels[id].impression;
        if (impression.comment) {
            push(`${routes.PANELS_IMPRESSION}${id}`, {
                impression: impression,
                id: id,
                code: forumPanels[id].code
            });
        } else {
            push(`${routes.PANELS_DETAILS}${id}`);
        }
    };

    const panels = item.panels.map(id => {
        if (!!forumPanels[id]) {
            const moderator = ` ${getFormattedNamesFromArray(forumPanels[id].moderators, forumSpeakers, "name")}`;
            const panelists = ` ${getFormattedNamesFromArray(forumPanels[id].speakers, forumSpeakers, "name")}`;
            const footer = `${strings.panel.END} ${getFormattedTime(forumPanels[id].endTime)}, `;
            return (
                <StyledItem key={id} sx={{ padding: 3 }}>
                    <StyledItemHeaderContainer
                        sx={{
                            paddingLeft: [2, 4],
                            paddingRight: [2, 4],
                            marginBottom: [1, 2]
                        }}>
                        <StyledItemHeader onClick={onClickHandler.bind(null, id)} sx={{ fontSize: [5], lineHeight: [1.2] }}>
                            {forumPanels[id].label}
                        </StyledItemHeader>
                        <FavoriteToggleButton id={id} renderItem={StyledFavButton} />
                    </StyledItemHeaderContainer>
                    <StyledContainer onClick={onClickHandler.bind(null, id)}>
                        <StyledParticipants sx={{ paddingLeft: [2, 4], paddingRight: [2, 4], fontSize: [3], marginBottom: [1, 2] }}>
                            {moderator && moderator.trim() !== "" && (
                                <>
                                    <StyledSpan>{strings.panel.MODERATOR}</StyledSpan>
                                    {moderator}
                                </>
                            )}
                        </StyledParticipants>
                        <StyledParticipants sx={{ paddingLeft: [2, 4], paddingRight: [2, 4], fontSize: [3] }}>
                            {panelists && panelists.trim() != "" && (
                                <>
                                    <StyledSpan>{strings.panel.PANELISTS}</StyledSpan>
                                    {panelists}
                                </>
                            )}
                        </StyledParticipants>
                        <StyledItemFooter
                            sx={{
                                fontSize: [3],
                                paddingLeft: [2, 4],
                                paddingRight: [2, 4],
                                marginTop: [1, 2]
                            }}>
                            {footer}
                            <StyledRoom>{forumPanels[id].room}</StyledRoom>
                        </StyledItemFooter>
                    </StyledContainer>
                </StyledItem>
            );
        } else {
            return null;
        }
    });
    return (
        <StyledItemContainer>
            <StyledTimeLabel>{getFormattedTime(item.startTime, "h")}</StyledTimeLabel>
            {panels}
        </StyledItemContainer>
    );
};

export default withLocalizeStrings(SpeechBlock);
